import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { withNamespaces } from 'react-i18next';
import classnames from 'classnames';
import { withRouter } from 'react-router';
import ReaderLogo from './Logo';
import './_styles.scss';

import { logout, showLogin } from 'modules/user/actions';
import {
  isAuthenticated,
  getUserProfile,
  isJournalist,
  isPressOfficer,
  isAdmin,
} from 'modules/user/reducers';
import { getSite } from 'modules/global/reducers';
import { LoggedOutHeaderMenu, LoggedOutProfileMenu } from './NotLoggedInMenu';
import { LoggedInHeaderMenu, LoggedInProfileMenu } from './LoggedInMenu';
import LoggedInMenuMobile from './LoggedInMenuMobile';
import NotLoggedInMenuMobile from './NotLoggedInMenuMobile';

const NEWSROOM_LINKS_BY_LOCALE = {
  da:
    'https://www.mynewsdesk.com/dk-da/dit-presserum-stedet-for-alt-dit-pressemateriale/',
  de:
    'https://www.mynewsdesk.com/de-de/insights/was-ist-eigentlich-berichtenswert/',
  en: 'https://www.mynewsdesk.com/en/online-newsroom/',
  fi: 'https://www.mynewsdesk.com/en/online-newsroom/',
  sv: 'https://www.mynewsdesk.com/se-sv/nyhetsrum/',
  no:
    'https://www.mynewsdesk.com/no-no/nyhetsrom-stedet-for-alt-pressemateriale/',
};

class Navigation extends PureComponent {
  constructor() {
    super();
    this.state = {
      isMobile: window.innerWidth <= 500,
    };
  }
  updateDimensions() {
    this.setState({ isMobile: window.innerWidth <= 500 });
  }

  ///**  Add event listener */
  componentDidMount() {
    this.updateDimensions();
    window.addEventListener('resize', this.updateDimensions.bind(this));
  }

  // /*** Remove event listener*/
  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDimensions.bind(this));
  }

  render() {
    const {
      isAuthenticated,
      showLogin,
      logout,
      t,
      site,
      profile,
      isPressOfficer,
      isJournalist,
      isAdmin,
    } = this.props;
    const { isMobile } = this.state;

    return (
      <div className="mnd-column-full">
        <nav
          className={classnames('beta mnd-navigation', {
            'mnd-navigation-mobile': isMobile,
          })}
        >
          <div className="mnd-navigation__logo">
            <a href="/" className="mnd-navigation-menu__item-hitarea">
              <ReaderLogo
                className="mnd-common-logo"
                alt="mynewsdesk | reader"
              />
            </a>
          </div>
          {isMobile &&
            (isAuthenticated ? (
              <LoggedInMenuMobile
                isJournalist={isJournalist}
                site={site}
                logout={logout}
                userId={profile.sub}
                isPressOfficer={isPressOfficer}
                isAdmin={isAdmin}
              />
            ) : (
              <NotLoggedInMenuMobile
                showLogin={showLogin}
                site={site}
                t={t}
                createNewsroomLink={
                  NEWSROOM_LINKS_BY_LOCALE[site.defaultLocale]
                }
              />
            ))}
          {!isMobile && (
            <>
              <div className="mnd-navigation__header">
                {isAuthenticated ? (
                  <LoggedInHeaderMenu
                    t={t}
                    site={site}
                    isJournalist={isJournalist}
                    isAdmin={isAdmin}
                  />
                ) : (
                  <LoggedOutHeaderMenu
                    t={t}
                    site={site}
                    createNewsroomLink={
                      NEWSROOM_LINKS_BY_LOCALE[site.defaultLocale]
                    }
                  />
                )}
              </div>

              <div className="mnd-navigation__main">
                <ul className="mnd-navigation-menu">
                  <li className="mnd-navigation-menu__item">
                    {isAuthenticated ? (
                      <LoggedInProfileMenu
                        logout={logout}
                        t={t}
                        userId={profile.sub}
                        isJournalist={isJournalist}
                        isPressOfficer={isPressOfficer}
                        site={site}
                        isAdmin={isAdmin}
                      />
                    ) : (
                      <LoggedOutProfileMenu showLogin={showLogin} t={t} />
                    )}
                  </li>
                </ul>
              </div>
            </>
          )}
        </nav>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  isAuthenticated: isAuthenticated(state),
  isJournalist: isJournalist(state),
  isAdmin: isAdmin(state),
  isPressOfficer: isPressOfficer(state),
  site: getSite(state),
  profile: getUserProfile(state),
});

const mapDispatchToProps = dispatch => ({
  showLogin: () => dispatch(showLogin()),
  logout: () => dispatch(logout()),
});

const mergeProps = ({ ...stateProps }, { ...dispatchProps }, ownProps) => ({
  ...stateProps,
  ...dispatchProps,
  ...ownProps,
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps,
  )(withNamespaces()(Navigation)),
);
